import type { SearchType } from '@domain/enums/SearchType';
import type { SearchRouteResolver } from './SearchRouteResolver';

/**
 * Process-wide registry of the search route resolvers. It deliberately doesn't import the generated
 * routes itself, so code that runs during route generation (e.g. the filter mappers) can depend on it.
 * `router.options.ts` registers the resolvers built from the generated routes.
 */
const resolvers = new Map<SearchType, SearchRouteResolver>();

export const registerSearchRouteResolvers = (searchRouteResolvers: SearchRouteResolver[]): void => {
	searchRouteResolvers.forEach(resolver => resolvers.set(resolver.searchType, resolver));
};

export const getSearchRouteResolver = (searchType: SearchType | undefined): SearchRouteResolver | undefined =>
	searchType ? resolvers.get(searchType) : undefined;

export const clearSearchRouteResolvers = (): void => {
	resolvers.clear();
};
